module.exports = __webpack_public_path__ + "static/media/place-2.66cfae78.png";